/** UK pound formatting for customer-facing prices. */
export const CURRENCY_CODE = 'GBP';
export const CURRENCY_SYMBOL = '£';

export function formatMoney(amount, { decimals = 2 } = {}) {
  const n = parseFloat(amount);
  if (Number.isNaN(n)) return `${CURRENCY_SYMBOL}0.00`;
  return `${CURRENCY_SYMBOL}${n.toFixed(decimals)}`;
}
